export default __webpack_public_path__ + "static/tab-img-8e86b11b0d3c7222bae8dc7841633bc8.png";